/* global BigInt */
import { formatMoney, moneyFromMinor } from '../money/exact-money.js';

function normalizeCurrencyCode(currencyCode) {
  return String(currencyCode || '').trim().toUpperCase();
}

export function formatMoneyFromMinorUnits(amountMinor, currencyCode, locale) {
  const money = moneyFromMinor({ amount: amountMinor, currency: normalizeCurrencyCode(currencyCode) });
  return formatMoney(money, locale, { style: 'currency', currencyDisplay: 'code', fallback: '-' });
}

export function formatPartnerMoneyFromMicroUnits(amountMicro, currencyCode, locale) {
  const normalizedCurrencyCode = normalizeCurrencyCode(currencyCode);
  const rawAmount = String(amountMicro ?? '').trim();

  if (!rawAmount) {
    return '-';
  }

  if (!/^\d+$/.test(rawAmount)) {
    return normalizedCurrencyCode ? `${rawAmount} ${normalizedCurrencyCode}` : rawAmount;
  }

  const microUnits = BigInt(rawAmount);
  const whole = microUnits / 1000000n;
  const fraction = (microUnits % 1000000n).toString().padStart(6, '0');
  const value = `${whole.toString()}.${fraction}`;

  return normalizedCurrencyCode ? `${value} ${normalizedCurrencyCode}` : value;
}
